<template>
  <section class="section photo_gallery section_responsive bg-gray-lighter" id="galerija">
      <div class="box-spacer">
        <h2 class="text-bold">Instagram novosti</h2>
      </div>
        <div class="shell-fluid shell-condensed">
          <div class="range range-condensed" data-lightgallery="group">
            <div  v-for="(post, index) in posts" :key="index" class="cell-sm-6 cell-md-4 cell-lg-3 image-item">
                <a class="thumb-ruby thumb-mixed_height-4" href="https://www.instagram.com/lightsupeventlighting/" target="_blank" data-lightgallery="group-item">
                  <img class="thumb-ruby__image" :src="post.images.standard_resolution.url" :alt="post.text" width="400" height="363">
                  <div class="thumb-ruby__caption"></div>
                </a>
            </div>
          </div>
        </div>      
  </section>
</template>

<script>
import axios from 'axios';
export default {   
  data () {
    return {
      access_token: "442454824.1677ed0.05e258309fc245268438a661a5f8a573",
      url: "https://api.instagram.com/v1/users/self/media/recent/",
      posts: [],
      error: false
    }
  },
  methods: {
    fetchData(){
      axios.get(this.url + "?access_token=" + this.access_token)
            .then(({data}) => {
              var posts = data.data;
              this.posts = posts.slice(4, 8);
            })
            .catch(function (error) {
              console.log(error)
              this.error = true
      });    
    },      
  },
  created(){
    this.fetchData();
  }
             
}
</script>

<style lang="scss">

.image-item{
  cursor:pointer;
  opacity: 1;
}

.shell-fluid{
      .range{
        .image-item{
          opacity: 1;

        }
      }
}

.hidden{
  display:none;
}


@media only screen and (max-width: 768px) {
  .photo_gallery{
    //Galerija
    .shell-fluid{
      .range{
        padding: 0 1rem;
        .image-item{
          width: 47.5%;
          max-width: 47.5%;
          margin-bottom: 1rem;

          &:nth-child(odd){
            margin-right: 5%;    
          }

          a{
            .thumb-ruby__caption{
              min-height: 100px !important;
              width: 100px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/Instagram.vue